export const webappPaths = {
  login: '/login',
};

export const authPaths = {
  login: '/login',
  signUp: '/sign-up',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
};

export const onHoldReason = {
  email: 'email',
  subscription: 'subscription',
  payment: 'payment',
  trial: 'trial',
};

export const appPaths = {
  base: '/',
  chart: '/chart',
  chartV2: '/chartv2',
  graph: '/graph',
  kgInsight: '/kg-insight',
  alfred: '/alfred',
  alfredSettings: '/alfred/settings',
  screener: '/screener',
  scenario: '/scenario',
  insights: '/insights',
  onboarding: '/onboarding',
  research: '/2-alfred',
  news: '/news',
  insightFeed: '/stream',
  alerts: '/alerts',
  settings: {
    base: '/settings',
    subscription: '/settings/subscription',
    account: '/settings/account',
    appearance: '/settings/appearance',
    following: '/settings/following',
    portfolio: '/settings/portfolio',
    notifications: '/settings/notifications',
  },
  verifyEmail: '/verify-email',
  accountOnHold: '/account-on-hold',
  error: '/error',
  notFound: '*',
  website: '/',
  alfredAppConnection: '/alfred/app-connection',
  alfredNotionConnection: '/alfred/notion-connection',
  assetOverview: '/asset-overview',
  themeOverview: '/theme',
  watchlist: '/watchlist',
  events: '/events',
  ib: '/ib',
  tos: '/terms-of-service',
};

const LEGACY_APP_PREFIX = '/app';

export const stripLegacyAppPrefix = (path: string) => {
  if (path.startsWith(`${LEGACY_APP_PREFIX}/static`)) {
    return path;
  }

  if (path === LEGACY_APP_PREFIX || path === `${LEGACY_APP_PREFIX}/`) {
    return '/';
  }

  if (path.startsWith(`${LEGACY_APP_PREFIX}/`)) {
    return path.slice(LEGACY_APP_PREFIX.length);
  }

  return path;
};

export const accountRoutes = {
  checkout: 'checkout',
  billingInformation: 'billing-information',
};

export const drawerKeys = {
  themeOverviewTab: 'themeOverviewTab',
} as const;
